/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentVisibilityOut
 */
export interface AttachmentVisibilityOut {
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentVisibilityOut
     */
    isPublic: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentVisibilityOut
     */
    isVisibleInCp: boolean;
    /**
     * 
     * @type {number}
     * @memberof AttachmentVisibilityOut
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof AttachmentVisibilityOut
     */
    modificationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof AttachmentVisibilityOut
     */
    attachmentId: number;
}

export function AttachmentVisibilityOutFromJSON(json: any): AttachmentVisibilityOut {
    return AttachmentVisibilityOutFromJSONTyped(json, false);
}

export function AttachmentVisibilityOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentVisibilityOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isPublic': json['isPublic'],
        'isVisibleInCp': json['isVisibleInCp'],
        'offerId': json['offerId'],
        'modificationDate': (new Date(json['modificationDate'])),
        'attachmentId': json['attachmentId'],
    };
}

export function AttachmentVisibilityOutToJSON(value?: AttachmentVisibilityOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isPublic': value.isPublic,
        'isVisibleInCp': value.isVisibleInCp,
        'offerId': value.offerId,
        'modificationDate': (value.modificationDate.toISOString()),
        'attachmentId': value.attachmentId,
    };
}


